import { Reveal, Eyebrow } from "@/components/Reveal";

const pairs = [
  "Money AND mornings with your babies.",
  "Ambition AND a wildly alive relationship.",
  "Impact AND oceans.",
  "Creation AND rest.",
  "Discipline AND pleasure.",
  "Business AND adventure.",
  "Wealth AND presence.",
];

export const PleasureSection = () => (
  <section data-testid="pleasure-section" className="relative overflow-hidden">
    <img
      src="/assets/life-love.jpg"
      alt=""
      aria-hidden="true"
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-ink/78" />
    <div className="relative mx-auto max-w-3xl px-5 py-28 text-center sm:py-40">
      <Reveal>
        <Eyebrow>PLEASURE IS PART OF THE PLAN</Eyebrow>
        <h2 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-6xl">
          WHAT IF SUCCESS
          <br />
          <span className="font-serif italic font-medium text-lime">FELT GOOD?</span>
        </h2>
      </Reveal>

      <Reveal className="mt-10" delay={0.1}>
        <p className="font-mono text-[11px] tracking-[0.35em] text-cream/50">YOUR VISION GETS TO INCLUDE:</p>
        <div className="mt-6 space-y-3">
          {pairs.map((p, i) => (
            <Reveal key={p} delay={Math.min(i * 0.05, 0.3)}>
              <p className="font-serif text-xl italic text-cream/85 sm:text-2xl">{p}</p>
            </Reveal>
          ))}
        </div>
      </Reveal>

      <Reveal className="mt-16" delay={0.15}>
        <p className="text-2xl font-extrabold leading-[1.1] tracking-tight sm:text-4xl">
          WE’RE NOT EXPANDING YOUR CAPACITY
          <br />
          SO YOU CAN WORK MORE.
        </p>
        <p className="mt-4 font-serif text-3xl italic leading-[1.1] text-lime sm:text-5xl">
          WE’RE EXPANDING YOUR CAPACITY
          <br />
          SO YOU CAN LIVE MORE.
        </p>
      </Reveal>
    </div>
  </section>
);
